module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-create-application.a99ec83a.png";